import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Fetches a single user's activity logs on a project for one day (YYYY-MM-DD).
 * With `from` and `to` (ISO timestamps, the viewer's local midnight and the
 * next one) the API returns the rows created in [from, to); without them,
 * the UTC day `date`, which misses the first hours of a day east of UTC.
 * The backend enforces the activity_log_view permission, looks up the
 * project's business_id and leaves out the rows of opening the project.
 * Returns the API payload (`{ items, images }`; an API from before `images`
 * answers `{ items }`).
 */
export const getActivityLogsForUserProjectDate = async ({
  projectId,
  userId,
  date,
  from,
  to,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const query =
    from && to
      ? `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
      : '';
  const apiPath = `activity-log/project/${projectId}/user/${userId}/${date}${query}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
